// Note: when updating this list please also update corresponding confluence page
// Glossary: International Countries flag currently supported in Tables module
const codeToCountry: Record<string, string | string[]> = {
	AF: "Afghanistan",
	AL: "Albania",
	DZ: "Algeria",
	AS: "American Samoa",
	AD: "Andorra",
	AO: "Angola",
	AI: "Anguilla",
	AQ: "Antarctica",
	AG: "Antigua and Barbuda",
	AR: "Argentina",
	AM: "Armenia",
	AW: "Aruba",
	AU: "Australia",
	AT: "Austria",
	AZ: "Azerbaijan",
	BS: "Bahamas",
	BH: "Bahrain",
	BD: "Bangladesh",
	BB: "Barbados",
	BY: "Belarus",
	BE: "Belgium",
	BZ: "Belize",
	BJ: "Benin",
	BM: "Bermuda",
	BT: "Bhutan",
	BO: "Bolivia",
	BA: "Bosnia and Herzegovina",
	BW: "Botswana",
	BV: "Bouvet Island",
	BR: "Brazil",
	IO: "British Indian Ocean Territory",
	BN: ["Brunei Darussalam", "Brunei"],
	BG: "Bulgaria",
	BF: "Burkina Faso",
	BI: "Burundi",
	KH: "Cambodia",
	CM: "Cameroon",
	CA: "Canada",
	IC: ["Canary Islands", "Spain - Canary Islands"],
	CV: "Cape Verde",
	KY: "Cayman Islands",
	CF: "Central African Republic",
	TD: "Chad",
	CL: "Chile",
	CN: ["People's Republic of China", "China"],
	CX: "Christmas Island",
	CC: ["Cocos (Keeling) Islands"],
	CO: "Colombia",
	KM: "Comoros",
	CG: ["Republic of the Congo"],
	CD: ["Democratic Republic of the Congo"],
	CK: "Cook Islands",
	CR: "Costa Rica",
	CI: ["Cote d'Ivoire", "Côte d'Ivoire", "Ivory Coast"],
	HR: "Croatia",
	CU: "Cuba",
	CY: "Cyprus",
	CZ: ["Czech Republic", "Czechia"],
	DK: "Denmark",
	DJ: "Djibouti",
	DM: "Dominica",
	DO: "Dominican Republic",
	EC: "Ecuador",
	EG: "Egypt",
	SV: "El Salvador",
	GQ: "Equatorial Guinea",
	ER: "Eritrea",
	EE: "Estonia",
	ET: "Ethiopia",
	FK: ["Falkland Islands (Malvinas)", "Falkland Islands", "Islas Malvinas"],
	FO: "Faroe Islands",
	FJ: "Fiji",
	FI: "Finland",
	FR: "France",
	GF: "French Guiana",
	PF: "French Polynesia",
	TF: "French Southern Territories",
	GA: "Gabon",
	GM: ["Republic of The Gambia", "The Gambia", "Gambia"],
	GE: "Georgia",
	DE: "Germany",
	GH: "Ghana",
	GI: "Gibraltar",
	GR: "Greece",
	GL: "Greenland",
	GD: "Grenada",
	GP: "Guadeloupe",
	GU: "Guam",
	GT: "Guatemala",
	GN: "Guinea",
	GW: "Guinea-Bissau",
	GY: "Guyana",
	HT: "Haiti",
	HM: "Heard Island and McDonald Islands",
	VA: ["Holy See (Vatican City State)", "Vatican City"],
	HN: "Honduras",
	HK: "Hong Kong",
	HU: "Hungary",
	IS: "Iceland",
	IN: "India",
	ID: "Indonesia",
	IR: ["Islamic Republic of Iran", "Iran"],
	IQ: "Iraq",
	IE: "Ireland",
	IL: "Israel",
	IT: "Italy",
	JM: "Jamaica",
	JP: "Japan",
	JO: "Jordan",
	KZ: "Kazakhstan",
	KE: "Kenya",
	KI: "Kiribati",
	KP: "North Korea",
	KR: ["South Korea", "Korea, Republic of", "Republic of Korea", "Korea"],
	KW: "Kuwait",
	KG: "Kyrgyzstan",
	LA: ["Lao People's Democratic Republic", "Laos"],
	LV: "Latvia",
	LB: "Lebanon",
	LS: "Lesotho",
	LR: "Liberia",
	LY: "Libya",
	LI: "Liechtenstein",
	LT: "Lithuania",
	LU: "Luxembourg",
	MO: ["Macao", "Macau"],
	MG: "Madagascar",
	MW: "Malawi",
	MY: "Malaysia",
	MV: "Maldives",
	ML: "Mali",
	MT: "Malta",
	MH: "Marshall Islands",
	MQ: "Martinique",
	MR: "Mauritania",
	MU: "Mauritius",
	YT: "Mayotte",
	MX: "Mexico",
	FM: ["Micronesia, Federated States of", "Micronesia"],
	MD: ["Moldova, Republic of", "Moldova"],
	MC: "Monaco",
	MN: "Mongolia",
	MS: "Montserrat",
	MA: "Morocco",
	MZ: "Mozambique",
	MM: ["Myanmar", "Burma"],
	NA: "Namibia",
	NR: "Nauru",
	NP: "Nepal",
	NL: ["Netherlands", "The Netherlands", "Netherlands (Kingdom of the)"],
	NC: "New Caledonia",
	NZ: "New Zealand",
	NI: "Nicaragua",
	NE: "Niger",
	NG: "Nigeria",
	NU: "Niue",
	NF: "Norfolk Island",
	MK: ["The Republic of North Macedonia", "North Macedonia", "Macedonia"],
	MP: "Northern Mariana Islands",
	NO: "Norway",
	OM: "Oman",
	PK: "Pakistan",
	PW: "Palau",
	PS: ["State of Palestine", "Palestine"],
	PA: "Panama",
	PG: "Papua New Guinea",
	PY: "Paraguay",
	PE: "Peru",
	PH: "Philippines",
	PN: ["Pitcairn", "Pitcairn Islands"],
	PL: "Poland",
	PT: "Portugal",
	PR: "Puerto Rico",
	QA: "Qatar",
	RE: "Reunion",
	RO: "Romania",
	RU: ["Russian Federation", "Russia"],
	RW: "Rwanda",
	SH: "Saint Helena",
	KN: "Saint Kitts and Nevis",
	LC: "Saint Lucia",
	PM: "Saint Pierre and Miquelon",
	VC: "Saint Vincent and the Grenadines",
	WS: "Samoa",
	SM: "San Marino",
	ST: "Sao Tome and Principe",
	SA: "Saudi Arabia",
	SN: "Senegal",
	SC: "Seychelles",
	SL: "Sierra Leone",
	SG: "Singapore",
	SK: "Slovakia",
	SI: "Slovenia",
	SB: "Solomon Islands",
	SO: "Somalia",
	ZA: "South Africa",
	GS: "South Georgia and the South Sandwich Islands",
	ES: "Spain",
	LK: "Sri Lanka",
	SD: "Sudan",
	SR: "Suriname",
	SJ: "Svalbard and Jan Mayen",
	SZ: ["Eswatini", "Swaziland"],
	SE: "Sweden",
	CH: "Switzerland",
	SY: ["Syrian Arab Republic", "Syria"],
	TW: ["Taiwan, Province of China", "Taiwan, Republic of China", "Taiwan"],
	TJ: "Tajikistan",
	TZ: ["United Republic of Tanzania", "Tanzania"],
	TH: "Thailand",
	TL: "Timor-Leste",
	TG: "Togo",
	TK: "Tokelau",
	TO: "Tonga",
	TT: "Trinidad and Tobago",
	TN: "Tunisia",
	TR: ["Türkiye", "Turkey"],
	TM: "Turkmenistan",
	TC: "Turks and Caicos Islands",
	TV: "Tuvalu",
	UG: "Uganda",
	UA: "Ukraine",
	AE: ["United Arab Emirates", "UAE"],
	GB: ["United Kingdom", "UK", "U.K.", "Great Britain", "Britain"],
	US: ["United States of America", "United States", "USA", "U.S.A.", "U.S."],
	UM: "United States Minor Outlying Islands",
	UY: "Uruguay",
	UZ: "Uzbekistan",
	VU: "Vanuatu",
	VE: "Venezuela",
	VN: ["Vietnam", "Viet Nam"],
	VG: ["Virgin Islands, British", "British Virgin Islands"],
	VI: ["Virgin Islands, U.S.", "United States Virgin Islands"],
	WF: "Wallis and Futuna",
	EH: "Western Sahara",
	YE: "Yemen",
	ZM: "Zambia",
	ZW: "Zimbabwe",
	AX: ["Åland Islands", "Aland Islands"],
	BQ: "Bonaire, Sint Eustatius and Saba",
	CW: "Curaçao",
	GG: ["Guernsey", "Jersey", "Channel Islands"],
	IM: "Isle of Man",
	JE: "Jersey",
	ME: "Montenegro",
	BL: "Saint Barthélemy",
	MF: "Saint Martin (French part)",
	RS: "Serbia",
	SX: "Sint Maarten (Dutch part)",
	SS: "South Sudan",
	XK: "Kosovo",
};

const namesToCode: Record<string, string> = Object.entries(codeToCountry).reduce(
	(acc, [code, names]) => {
		const nameList = Array.isArray(names) ? names : [names];
		for (const name of nameList) {
			acc[name] = code;
		}
		return acc;
	},
	{} as Record<string, string>
);

export const getCountryFlag = (text: string): string => {
	const trimmed = text.trim();
	const exact = namesToCode[trimmed];
	if (exact) return exact;

	const normalized = trimmed
		.replace(/\(([^)]*)\)/g, "")
		.replace(/\s{2,}/g, " ")
		.trim();

	return namesToCode[normalized] ?? "";
};
